module.exports = __webpack_public_path__ + "img/banner genérico-0446.1bcca39b.jpg";